import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

// API instance without authorization headers
const publicApi = axios.create({
  baseURL: apiUrl,
});

export default publicApi;
